module.exports = __webpack_public_path__ + "img/hr-tree-09-e-leaves.7a30a915.png";